import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft, BookOpen } from "lucide-react";

const STEPS = [
  "Open SayIt",
  "Find the situation you're dealing with",
  "Choose Warm, Balanced or Firm",
  "Customize the bracketed details",
  "Use it",
];

export default function ThankYou() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <main className="mx-auto flex min-h-screen max-w-2xl flex-col justify-center px-4 py-24 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-faint">
            Purchase confirmed
          </p>
          <h1
            data-testid="thankyou-headline"
            className="mt-6 font-display text-5xl font-light tracking-tight text-ink sm:text-6xl"
          >
            You're in.
          </h1>
          <p className="mt-6 max-w-md text-base leading-relaxed text-smoke sm:text-lg">
            Your SayIt Manager Edition is ready. Check your email or use the
            download provided after checkout.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
          className="mt-12 rounded-2xl border border-line bg-white p-8"
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-faint">
            What to do next
          </p>
          <ol className="mt-6 space-y-4">
            {STEPS.map((s, i) => (
              <li key={s} className="flex items-baseline gap-4">
                <span className="font-mono text-xs tracking-[0.15em] text-faint">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-sm text-ink">{s}</span>
              </li>
            ))}
          </ol>
          <button
            type="button"
            data-testid="thankyou-download-button"
            className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-ink px-6 py-3 text-sm font-medium text-paper transition-colors duration-200 hover:bg-black"
          >
            <BookOpen className="h-4 w-4" />
            Open your download
          </button>
          <p className="mt-3 text-[13px] text-faint">
            Your download link is also in your receipt email from Lemon Squeezy.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-10"
        >
          <Link
            to="/"
            data-testid="thankyou-back-home-link"
            className="inline-flex items-center gap-2 text-sm text-smoke transition-colors hover:text-ink"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to SayIt
          </Link>
        </motion.div>
      </main>
    </div>
  );
}
